import { environment } from "../../../../../environments/environment";
import { PaymentService } from "../../../stores/payment/interfaces/payment-service";
import { EndpointHelper } from "../../endpoint.helper";
import { HttpClient } from "../../http";

export interface PayAtTokenizeResponse {
  tokenPaymentUrl: string
  [key: string]: any
}
export interface PayAtRedirectResponse {
  webPaymentLinks: PayAtOption[];
  [key: string]: any
}

export interface PayAtOption {
  paymentMethodName: "CARD" | "CAPITEC_EFT" | "EFT",
  paymentUrl: string
}

export class PayAtPaymentService implements PaymentService<any> {
  public canStatusPoll = false;
  public canRefetchPoll = false;

  private apiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}/payat`);

  MakePayment(requestBody?: Partial<any>): Promise<any[]> {
    const url = this.apiBuilder.createUrl('initiate')
      .addRouteParam('full')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtRedirectResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return response.webPaymentLinks;
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  TokenLinks(requestBody?: any) {
    const url = this.apiBuilder.createUrl('token')
      .addRouteParam('paymentLink')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtTokenizeResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return {
            redirectUrl: response.tokenPaymentUrl,
            transactionId: response.referenceKey,
            paymentType: `${response.responseCode}`
          }
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  // NOTE: in order to use this we will need an MC service that returns tokenized cards
  TokenPayment(requestBody: any) {
    const url = this.apiBuilder.createUrl('token')
      .addRouteParam('payment')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtRedirectResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return response;
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }


  PaymentStatus(country: string, orderId: string): Promise<any> {
    return Promise.reject(`PayAtPaymentService -> PaymentStatus not implemented`);
  }

  RefetchPayment() {
    return Promise.reject('PayAtPaymentService -> RefetchPayment Not Implemented')
  }
}
